import React from 'react';
import {Row, Col, Card} from 'react-materialize';


import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

const Sobre = () => (

    <Card>

        <Row>
            <div align="center">
                <h5><p><b><FormattedMessage id={"yourself_protection_title"} defaultMessage={"Como se proteger?"}/></b></p></h5>
            </div>
            <div align="justify" style={{padding:"50px"}}>
                <ol>
                    <li><FormattedMessage id={"yourself_protection_text_1"} defaultMessage={"Prefira lavar suas mãos com sabão e água."}/></li>
                    <li><FormattedMessage id={"yourself_protection_text_2"} defaultMessage={"Limpe suas mãos com álcool gel."}/></li>
                    <li><FormattedMessage id={"yourself_protection_text_3"} defaultMessage={"Não toque seu rosto."}/></li>
                    <li><FormattedMessage id={"yourself_protection_text_4"} defaultMessage={"Quando tossir ou espirrar, pratique a etiqueta respiratória (tossir em um braço com seu cotovelo flexionado)."}/></li>
                    <li><FormattedMessage id={"yourself_protection_text_5"} defaultMessage={"Evite contato físico (abraços, apertos de mão e beijos devem ser evitados)."}/></li>
                </ol>
            </div>
            
            <div align="center">
                <a href={"/protection"} style={{background:'white', color: 'black'}}>
                    <button style={{backgroundColor:"#7F7FFF", border:"white", borderRadius:"15px"}}>
                        <h5><FormattedMessage id={"back"} defaultMessage={"VOLTAR"}/></h5>
                    </button>
                </a>
            </div>
        </Row>

        

    </Card>

);

export default Sobre;